import { db } from './firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

export const emailService = {
  // Send a single email using a template
  sendTemplatedEmail: async (to, templateName, templateData) => {
    try {
      await addDoc(collection(db, 'mail'), {
        to,
        template: {
          name: templateName,
          data: templateData
        },
        createdAt: serverTimestamp()
      });
      return { success: true };
    } catch (error) {
      console.error('Error queueing email:', error);
      return { success: false, error: error.message };
    }
  },

  // Send a custom email (no template)
  sendCustomEmail: async (to, subject, htmlContent) => {
    try {
      await addDoc(collection(db, 'mail'), {
        to,
        message: {
          subject,
          html: htmlContent
        },
        createdAt: serverTimestamp()
      });
      return { success: true };
    } catch (error) {
      console.error('Error queueing custom email:', error);
      return { success: false, error: error.message };
    }
  },

  // Send bulk emails to multiple users
  sendBulkEmails: async (recipients, subject, htmlContent) => {
    try {
      const promises = recipients.map(to => 
        emailService.sendCustomEmail(to, subject, htmlContent)
      );
      await Promise.all(promises);
      return { success: true, count: recipients.length };
    } catch (error) {
      console.error('Error queueing bulk emails:', error);
      return { success: false, error: error.message };
    }
  }
};
